export const TRACE_TABLE_MATURITY_DATE_FORMAT = 'LLL d, yyyy';
export const TRACE_TABLE_TRADE_FORMAT = 'LLL d, yyyy HH:mm:ss';

export enum Periods {
  MONTH = 'month',
  QUARTER = 'quarter',
  YEAR = 'year',
}

export enum RatingTypesNames {
  MO = "Moody's",
  SP = 'S&P',
  FI = 'Fitch',
  DR = 'DBRS',
  KR = 'Kroll Bond',
  MS = 'Morningstar',
}

export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_MAX_LENGTH = 128;

export const EMPTY_CELL_STATE = '-';
